<div>
    <h4 class="m-t-10">Select a note</h4>
    <nz-select nzShowSearch  [(ngModel)]="noteSelected" style="width: 100%" (ngModelChange)="noteCannedReply(noteSelected)">
        <nz-option nzLabel="Add New" [nzValue]="-1"></nz-option>
        <nz-option nzLabel="Please have a look at the ..." [nzValue]="0"></nz-option>
        <nz-option nzLabel="Requesting additional investigation for ..." [nzValue]="1"></nz-option>
        <nz-option nzLabel="Required Documents are not in place ..." [nzValue]="2"></nz-option>
    </nz-select>

    <h4 class="m-t-10">Subject</h4>
    <input type="text" nz-input [ngModel]="note"/>

    <h4 class="m-t-10">Content</h4>
    <textarea rows="2" nz-input [(ngModel)]="note"></textarea>
  
</div>